import { sessionStore } from './services/sessionStore';

export { SESSION_END_REASON, SESSION_STATUS } from './constants';
export * from './useCases';

/** Ends the session here and now; the server is told without waiting for it. */
export const logout = () => sessionStore.logout();

/** Tries again to restore a session the server could not be reached for. */
export const retrySession = () => sessionStore.retry();

/** Signs in with the Google SSO hand-off token; `false` if it is malformed. */
export const signInWithSsoToken = (hex) => sessionStore.signInWithSsoToken(hex);

/** Runs `listener(reason)` every time a session ends. Returns the unsubscribe. */
export const onSessionEnded = (listener) => sessionStore.onSessionEnded(listener);
